import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  TextField,
  InputAdornment,
  SvgIcon,
  makeStyles,
  Button,
  Typography
} from '@material-ui/core';
import { Search as SearchIcon, Plus as PlusIcon } from 'react-feather';
import ImportCupons from './ImportCupons';

const useStyles = makeStyles(theme => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  container2: {
    display: 'flex',
    flexDirection: 'row',
    spacing: 20
  },
  SearchInput: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 10
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: '50%'
    },
    width: '100%'
  }
}));

const Toolbar = ({
  className,
  cupons,
  setCuponsSearch,
  input,
  setInput,
  openModal,
  permissions,
  setRefresh,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box mt={3} className={classes.container}>
        <Box maxWidth={500} className={classes.SearchInput}>
          <TextField
            fullWidth
            value={input}
            onChange={e => {
              setInput(e.target.value);
              if (e.target.value.length > 0) {
                const filteredCupons = cupons.filter(c => {
                  if (c.seller)
                    return (
                      c.codigo
                        .toLowerCase()
                        .match(e.target.value.toLowerCase()) ||
                      c.seller?.nome
                        ?.toLowerCase()
                        .match(e.target.value.toLowerCase())
                    );
                  else {
                    return c.codigo
                      .toLowerCase()
                      .match(e.target.value.toLowerCase());
                  }
                });
                console.log(e.target.value, filteredCupons);
                setCuponsSearch(filteredCupons);
              } else {
                setCuponsSearch(cupons);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              )
            }}
            placeholder="Buscar cupons"
            variant="outlined"
          />
        </Box>

        <Box>
          {permissions.adicionar && <ImportCupons setRefresh={setRefresh} />}

          {permissions.adicionar && (
            <Button onClick={openModal} color="primary" variant="contained">
              <Typography
                style={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight:40
                }}
              >
                <PlusIcon style={{ paddingRight: 3 }} />
                Adicionar novo cupom
              </Typography>
            </Button>
          )}
        </Box>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
